// TYPE ELITE — Custom lettering controls (stroke, corners, width, connections, etc.)
// These become natural-language lettering directives in the compiled prompt.
export const LETTERING_CONTROLS = {
  strokeContrast: ['(unset)','Very Thin','Thin','Medium','Bold','Extra Bold','Ultra Heavy','High Stroke Contrast','Low Stroke Contrast','Reversed Contrast'],
  corners: ['(unset)','Sharp Corners','Slightly Rounded','Rounded','Very Rounded','Chiseled Corners','Notched Corners','Softly Blunted'],
  width: ['(unset)','Ultra Condensed','Condensed','Slightly Narrow','Normal Width','Slightly Wide','Extended','Ultra Extended'],
  height: ['(unset)','Very Short','Short','Normal Height','Tall','Extra Tall','Skyscraper Tall'],
  stems: ['(unset)','Straight Vertical Stems','Slightly Curved Stems','Flared Stems','Tapered Stems','Wavy Stems','Broken Stems'],
  serifStyle: ['(unset)','No Serifs','Small Slab Serifs','Traditional Serifs','Bracketed Serifs','Wedge Serifs','Split Serifs','Oversized Slab Serifs','Ornamental Serifs','Reversed / Italian Serifs'],
  connections: ['(unset)','Separated Letters','Lightly Connected','Fully Connected Script','Ligatures Between Pairs','Interlocking Letters','Overlapping Letters'],
  swashes: ['(unset)','No Swashes','Subtle Swashes','Long Elegant Swashes','Terminal Curls','Floral Flourishes','Ribbon Swashes','Asymmetric Swashes'],
  caseStyle: ['(unset)','All Uppercase','All Lowercase','Title Case','Mixed Case Random','Small Caps','Alternating Caps'],
  sizeMix: ['(unset)','Equal Size Letters','Alternating Big-Small','Descending Size','Ascending Size','Hero Word Bigger','First Letter Bigger'],
  baseline: ['(unset)','Flat Baseline','Slight Baseline Wobble','Bouncing Baseline','Ascending Baseline','Descending Baseline','Random Baseline Chaos'],
  counters: ['(unset)','Wide Open Counters','Tight Closed Counters','Slotted Counters','Filled-In Counters','Decorated Counters'],
  terminals: ['(unset)','Sharp Terminals','Rounded Terminals','Ball Terminals','Teardrop Terminals','Angular Cut Terminals','Split Terminals'],
  decoration: ['(unset)','Plain','Object Substitutions','Prop-Shaped Letters','Integrated Iconography','Decorative Punctuation','Custom Symbols In Place'],
};

export const SPACING_PRESETS = {
  tracking: [
    { label: 'Very Tight', val: -8 },
    { label: 'Tight', val: -4 },
    { label: 'Normal', val: 0 },
    { label: 'Wide', val: 6 },
    { label: 'Very Wide', val: 14 },
    { label: 'Extreme Wide', val: 24 },
  ],
  wordSpacing: [
    { label: 'Tight', val: -2 },
    { label: 'Normal', val: 0 },
    { label: 'Wide', val: 6 },
    { label: 'Extra Wide', val: 14 },
  ],
  lineSpacing: [
    { label: 'Tight', val: -8 },
    { label: 'Normal', val: 0 },
    { label: 'Airy', val: 10 },
    { label: 'Extra Airy', val: 24 },
  ],
  stackGap: [
    { label: 'Overlapping', val: -10 },
    { label: 'Touching', val: 0 },
    { label: 'Snug', val: 6 },
    { label: 'Spaced', val: 18 },
  ],
};

export const CHARACTER_SET_PRESETS = [
  { id: 'cs-alpha-upper', label: 'Uppercase A–Z', chars: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' },
  { id: 'cs-alpha-lower', label: 'Lowercase a–z', chars: 'abcdefghijklmnopqrstuvwxyz' },
  { id: 'cs-numbers', label: 'Numbers 0–9', chars: '0123456789' },
  { id: 'cs-symbols', label: 'Symbols & Punctuation', chars: "!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~" },
  { id: 'cs-all', label: 'Full Alphabet Sheet (A-Z, a-z, 0-9)', chars: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ abcdefghijklmnopqrstuvwxyz 0123456789' },
];
